import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="text-center bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
            <h1 className="text-3xl font-semibold text-gray-800 mb-4">
              Oops! Un problème est survenu.
            </h1>
            <p className="text-gray-600 mb-6">
              Nous rencontrons des difficultés techniques. Vous pouvez essayer de
              rafraîchir la page ou revenir en arrière.
            </p>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => window.location.reload()}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-200"
              >
                Actualiser la page
              </button>

              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition duration-200"
              >
                Retour à la page précédente
              </button>
            </div>

            <div className="mt-6">
              <button
                onClick={() => (window.location.href = "/dashboard")}
                className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition duration-200"
              >
                Aller au tableau de bord
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
